<template>
  <el-input :value="result" @input="checked" ref="el">
    </el-input>

</template>

<script>
export default {
	data() {
		return {
			result: 0,
		};
	},
	props:['value'],
	watch:{
		value(new_num){
			this.result = new_num;
		}
	},
	methods:{
		checked(new_num){
			new_num = new_num.replace(/[^\d|\.|\-]/g,'');
			let v = parseFloat(new_num);
			this.result = !isNaN(new_num) ? new_num : 0;
			this.$refs.el.currentValue = this.result;
			this.$emit('input', v||0);
		}
	}
}
</script>
